<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        서버 정보
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Server</a>
        </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else class="animated fadeIn fadeOut">
      <template v-if="quick_setting_status">
        <RuleQuickSetup
          :now_policy="now_policy"
          @toggle="x => quick_setting_status = x"
          @save="x => save_policy_quick(x)"
        >
        </RuleQuickSetup>
      </template>
      <b-card v-if="server && !quick_setting_status" class="animated fadeIn fadeOut" style="position:sticky; top:100px; z-index:15;">
        <b-row style="height: 65px !important; vertical-align: middle; cursor: pointer;">
          <b-col class="float-left mobile_hide mobile_hide_icon">
            <img src="img/icons/conf_logo.png" alt="" class="icon_45" style="margin: 5px 10px;" @click="apply_modal = true">
            <div class="d-inline-block" style="width: fit-content;">
              <p style="position:absolute; top:-10px; font-size:1.9rem; font-weight: bold">WAF 설정</p>
              <span style="position:absolute; top:40px;color:gray; font-weight:bold; font-size:1.2rem; ">Host Name : {{server.host}}</span>
            </div>
          </b-col>
          <b-col class="text-right font-weight-bold">
            <span v-if="is_require_save" class="font-weight-bold text-danger" style="position: absolute; top: -25px; right:75px;">
              * 정책 변경 사항이 있습니다 변경 사항을 확인하고 저장하세요
            </span>

            <div class="d-inline-block text-center" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <div class="custom-control custom-switch custom-switch-xl mb-2">
                  <input
                    :disabled="server.lock || is_require_save_style"
                    v-on:change="status_save($event, server.policy_json.status)"
                    v-model="server.policy_json.status"
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch3">
                  <label class="custom-control-label" for="customSwitch3">
                  </label>
              </div>
              <p for="customSwitch3" style="font-size: 9pt; display:inline-block;">엔진 활성화</p>
              <label class="text-info d-inline-block" v-b-tooltip.hover title="정책으로 인한 장애가 생길 경우 방화벽 엔진의 사용 여부를 설정할 수 있습니다 변경시 즉시 반영됩니다" style="cursor: pointer;" >
                <i class="fa fa-question-circle"></i>
              </label>
            </div>
            <div class="d-inline-block text-center" @click="quick_setting_status = true" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_quick.png" class="d-inline-block icon_45" alt="" @click="() => (server.lock || is_require_save_style) ? '' :  apply_modal = true">
              <p style="font-size: 9pt;">빠른 설정</p>
            </div>
            <div class="d-inline-block text-center" @click="modal_upload_policy = true" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_upload.png" class="d-inline-block icon_45" alt="" @click="() => (server.lock || is_require_save_style) ? '' :  apply_modal = true">
              <p style="font-size: 9pt;">정책 업로드</p>
            </div>
            <div class="d-inline-block text-center" @click="download_policy" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_download.png" class="d-inline-block icon_45" alt="" @click="() => (server.lock || is_require_save_style) ? '' :  apply_modal = true">
              <p style="font-size: 9pt;">정책 다운로드</p>
            </div>
            <div class="d-inline-block text-center" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_delete.png" class="d-inline-block icon_45" alt="" @click="() => (server.lock || is_require_save_style) ? '' : toggle.modal_del = true">
              <p style="font-size: 9pt;">삭제</p>
            </div>
            <div  class="d-inline-block text-center" :class="{ 'op-25' : server.lock || is_require_save_style }">
              <img src="img/icons/conf_list.png" class="d-inline-block icon_45" alt="" @click="server.lock ? '' : list()">
              <p style="font-size: 9pt;">목록</p>
            </div>
            <!-- TODO : 2022.08 버전에서 배포 -->
            <!-- <div class="d-inline-block text-center">
              <img src="img/share.png" class="d-inline-block icon_45" alt="" @click="apply_modal = true">
              <p style="font-size: 9pt;">다른 서버 적용</p>
            </div> -->
            <div class="d-inline-block text-center" :class="{ 'op-25' : server.lock }">
              <img src="img/icons/conf_save.png" class="d-inline-block icon_45" alt="" @click="rule_confirm = true">
              <p style="font-size: 9pt;">저장</p>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <!-- 아래부터 해야 함 -->
      <b-card v-if="server && !quick_setting_status" style="border: none; box-shadow: none; margin: 0;" no-body>
        <b-card-body style="padding: 5px !important;">
        <b-row class="text-center">
          <b-col md="3">
            <b-card style="box-shadow: 2px 2px 5px darkgray; height: 650px !important;">
              <div style="height: 450px; width: 1px; border: 1px solid gray; margin: 0 auto; position: absolute; z-index:0; left:50%; transform:translateX(-50%); margin-top: 100px;">
              </div>
              <div style="font-size: 14pt; margin: 10px 0px; font-weight: bold;" class="text-left">
                서버 정보
              </div>
              <img v-b-tooltip.hover title="온라인일 경우 컬러로 오프라인일 경우 흑백으로 표시됩니다" :src="info.is_online ? 'img/icons/host_on.png' : 'img/icons/host_off.png'" alt="" class="img-fluid" width="180" style="margin-bottom: 20px; position: relative;">
              <!-- 도메인 -->
              <div class="d-inline-block text-ccenter" style="z-index: 100; width:100%; margin: 15px 0px; border: 2px solid #2F5597; border-radius: 2px; height:80px;">
                <!-- left -->
                <div class=" mobile_hide" style="display: flex; justify-content: center; align-items: center; font-size: 0.9rem; font-weight: bold; box-sizing: border-box; float:left; width:40%; height:100%; background-color:#2F5597; color:white;">
                  <span style="">
                    도메인
                    <span class="text-info" v-b-tooltip.hover :title="`현재 ${now_policy.domain} 도메인을 설정하고 있습니다 도메인별로 정책을 설정할 수 있습니다 설정되지 않는 도메인은 default 도메인이 기본적으로 설정됩니다`">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>

                <!-- right -->
                <div class="mobile_extra" style="width:60%; height:100%; float:right; background-color:white; position:relative;">
                  <b-form-select v-if="server.policy_json.domains" v-model="now_policy.domain" @change="change_domain($event, now_policy.id)" size="sm" style="text-align: center; font-size: 12pt; width: 70%; margin-top:20px;">
                    <option v-for="(item,index) in server.policy_json.domains" :key="index" :value="item.domain">{{item.domain}} </option>
                  </b-form-select>
                </div>
              </div>
              <!-- WAS -->
              <div class="d-inline-block text-ccenter" style="z-index: 100; width:100%; margin: 15px 0px; border: 2px solid #203864; border-radius: 2px; height:80px;">
                <!-- left -->
                <div class=" mobile_hide" style="display: flex; justify-content: center; align-items: center; font-size: 0.9rem; font-weight: bold; box-sizing: border-box; float:left; width:40%; height:100%; background-color:#203864; color:white;">
                  <span style="">
                    WAS
                  </span>
                </div>

                <!-- right -->
                <div class="mobile_extra" style="display: flex; justify-content: center; align-items: center; height: 100%; width:60%; float:right; padding: 10px 0px; background-color:white; position:relative;">
                  <img v-if="server.iwaf_type == 'iis'" src="img/logos/was_iis.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'apache'" src="img/logos/was_apache.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'nginx'" src="img/logos/was_nginx.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'lsws'" src="img/logos/was_lsws.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'jeus'" src="img/logos/was_jeus.png" alt="" class="logo_120">
                  <img v-if="server.iwaf_type == 'tomcat'" src="img/logos/was_tomcat.png" alt="" class="logo_120">
                </div>
              </div>
              <!-- OS -->
              <div class="d-inline-block text-ccenter" style="z-index: 100; width:100%; margin: 15px 0px; border: 2px solid #222A35; border-radius: 2px; height:80px;">
                <!-- left -->
                <div class="mobile_hide" style="display: flex; justify-content: center; align-items: center; font-size: 0.9rem; font-weight: bold; box-sizing: border-box; float:left; width:40%; height:100%; background-color:#222A35; color:white;">
                  <span style="">
                    OS
                  </span>
                </div>

                <!-- right -->
                <div class="mobile_extra" style="display: flex; justify-content: center; align-items: center; width:60%; float:right; padding: 10px 0px; height:100%; background-color:white; position:relative;">
                  <img v-if="server.os_type == 'linux'" src="img/logos/os_linux.png" alt="" class="logo_120">
                  <img v-else src="img/logos/os_windows.png" alt="" class="logo_120">
                </div>
              </div>
            </b-card>
          </b-col>

          <b-col class="text-left">
            <b-card style="box-shadow: 2px 2px 5px darkgray;" class="mobile_webcastle_card_height">
              <b-row class="text-left">
                <b-col>
                  <p class="h4 font-weight-bold">네트워크 정보</p>
                </b-col>
                <b-col>
                  <p class="h4 font-weight-bold">웹방화벽 정보</p>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col md="6">
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        외부
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        {{server.ip_addr_public}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        내부
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        {{server.ip_addr_private}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        이름
                        <span class="text-info" v-b-tooltip.hover title="서버 호스트명과 다르게 이름을 지정할 수 있습니다">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </label>
                    </b-col>
                    <b-col>
                      <span class="col-form-label float-right">
                        <b-link href="javascript:void(0)" @click="name_modify_modal = true">
                          {{server.nickname | truncate(15) }}
                        </b-link>
                      </span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        이중화
                        <span @click="modal_duplex = true" class="text-info" v-b-tooltip.hover title="클릭시 지원 가능한 이중화 범위 확인이 가능합니다">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        <small>
                          준비중
                        </small>
                      </label>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col style="border-left: 1px solid silver;">
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        <!-- <Bell :size="16" :count="1" v-if="is_available_mmdb_update" style="position: absolute; left:50px;" /> -->
                        WAF
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        {{server.version}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        <Bell :size="16" :count="1" v-if="is_available_mmdb_update" style="position: absolute; left:60px;" />
                        GEO
                        <span style="margin-left: 40px;" v-if="is_available_mmdb_update && webcastle_mmdb"> v{{ webcastle_mmdb }}</span>
                      </label>
                    </b-col>
                    <b-col>

                      <label :class="(is_available_mmdb_update ? 'text-weight-bold col-form-label text-danger float-right' : 'col-form-label float-right')">
                        v{{server.mmdb_version}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        <Bell style="position: absolute; left:60px;" :size="16" :count="crs_rule_count" v-if="latest_policy_version" />
                          정책
                          <b-link href="javascript:void(0)" @click="upgrade_policy_modal = true" v-if="latest_policy_version">
                            <span style="margin-left: 40px;" v-if="is_available_mmdb_update && latest_policy_version">
                              v{{ latest_policy_version }}
                            </span>
                          </b-link>
                      </label>
                    </b-col>
                    <b-col>
                      <label :class="(latest_policy_version ? 'col-form-label text-weight-bold text-danger float-right' : 'col-form-label float-right')">
                        {{crs_rule.version}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mobile_hide_col">
                      <label class="col-form-label">
                        정책 구분
                        <span class="text-info" v-b-tooltip.hover title="정책의 구분을 표시합니다 테스트 정채, 호스팅사 정책, 기본 정책 등이 제공될 수 있습니다">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </label>
                    </b-col>
                    <b-col>
                      <label class="col-form-label float-right">
                        <small>
                          준비중
                        </small>
                      </label>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
            <b-card style="box-shadow: 2px 2px 5px darkgray;" class="mobile_webcastle_card_height_domain">
              <b-row>
                <b-col class="text-center">
                  <p class="text-left" style="font-size: 1.2rem; font-weight: bold; margin: 0;">
                    <span v-if="is_changed('domain')" style="width: 10px; height:10px; background-color:red; border-radius:10px; position:absolute; left:0px;"></span>
                    도메인 설정
                    <span class="text-info" v-b-tooltip.hover title="특정 도메인에 정책을 설정할 수 있습니다">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </p>
                  <p style="font-size: 3.2rem; font-weight: bold; margin:10px auto;">
                    {{server.policy_json.domains.length}}
                  </p>
                  <b-button size="sm" style="margin: 10px 5px;" variant="primary" @click="toggle.modal_domain_manage = true">도메인 관리</b-button>
                  <p style="font-weight: bold; font-size: 0.8rem;">
                    * 도메인을 설정하지 않을 경우
                    <br>
                    default 정책이 반영 됩니다
                  </p>
                </b-col>
                <b-col class="text-center" md="6" style="vertical-align: middle; border-left: 1px solid silver;">
                  <p class="text-left" style="font-size: 1.2rem; font-weight: bold; margin: 0;">
                    정책 구성 비율
                    <span class="text-info" v-b-tooltip.hover title="미사용, 탐지, 차단 정책의 구성을 표시합니다">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </p>
                  <VueApexCharts style="max-height:350px!important; margin: 0 auto;" :height="250" type="donut" ref="_chart_policy" :options="info.chart.policy.option" :series="info.chart.policy.series" />
                  <!-- TODO : 보안 레벨 부분은 향후 2023 출시 예정 -->
                  <!-- <span style="font-size: 18pt; font-weight: bold;">
                    보안 레벨
                    <span class="text-info" style="cursor: pointer;" @click="explain_level = true" v-b-tooltip.hover title="클릭하면 설명 문구가 표시됩니다">
                      <i class="fa fa-question-circle"></i>
                    </span>
                  </span>

                  <p class="mt-5">
                    <div v-for="item, index in codes.WAF_LEVEL" :key="'_level'+index" style="margin: 5px 10px; padding: 5px 15px; display: inline-block; width: 50px;">
                      <div>
                        <div @click="now_policy.level = item" :style="`width: 12px; height: 12px; border-radius: 50%; border: 12px solid ${item > now_policy.level ? 'silver' : '#5858ed'};position:absolute; `"></div>
                        <div :style="` width: 22px; height: 22px; border-radius: 50%; border: 20px solid #5858ed;position:relative; opacity:${item == now_policy.level ? '0.3' : '0'}; left: -8px; top: -8px;`"></div>
                      </div>

                      <div style="width: 100%; font-size: 22pt; font-weight: bold; margin-top: 15px; cursor: pointer;" @click="now_policy.level = item">
                        {{item}}
                      </div>
                    </div>
                  </p> -->

                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col class="wc_log_right">
            <LogList enable_paging="true" custom_title="탐지 로그" :only_view="true" :agent_id="server.id" :summary="true" :dc="true" @detail="x => { modal_log_id = x; toggle.modal_log = true }" custom_style="max-height: 650px !important;height: 650px !important; box-shadow: 2px 2px 5px darkgray;" show_count="10" />
            <!-- TODO : 향후 레벨 개념이 있을 경우 차트 필요 -->
            <!-- <b-card style="box-shadow: 2px 2px 5px darkgray;">
              <BarChart v-if="summary.level.chart" :chartData="summary.level.chart" :options="{}" />
            </b-card> -->
          </b-col>


          <!-- 제어 -->
          <!-- <b-col>
            <div>
              <b-button block size="sm" class="btn-addition" variant="success" @click="rule_confirm = true">정책 저장하기
              </b-button>
              <b-button block size="sm" class="mb-2" variant="warning" @click="apply_modal = true">다른 서버로 복사하기</b-button>

              <b-button size="sm" v-if="server.is_alive" block @click="toggle.modal_del = true" variant="danger">삭제하기</b-button>
              <b-button class="mt-2" size="sm" block variant="light" @click="list()">목록으로</b-button>
            </div>
          </b-col> -->
        </b-row>
        <b-row class="text-center wc_log_row mb-4">
          <b-col>
            <LogList enable_paging="true" custom_title="탐지 로그" :only_view="true" :agent_id="server.id" :summary="true" :dc="true" @detail="x => { modal_log_id = x; toggle.modal_log = true }" custom_style="max-height: 650px !important;height: 650px !important; box-shadow: 2px 2px 5px darkgray;" show_count="10"/>
          </b-col>
        </b-row>
        <hr>
        <b-row class="text-center">
          <b-col>
            <b-button v-b-tooltip.hover title="에이전트가 온라인일 경우 확인 할 수 있습니다" aria-controls="collapse-1" @click="toggle_resource" variant="primary" :disabled="!info.is_online" v-b-toggle.collapse-3 class="m-1" style="position: relative; top: -38px; margin:auto 0px;">
              시스템 자원 모니터링
            </b-button>
          </b-col>
        </b-row>
        <!-- 아래 차트 -->
        <b-collapse v-model="toggle.chart" id="collapse-1">
          <vcl-facebook v-if="!info.chart.memory.series.length" class="mb-4"></vcl-facebook>
          <b-row class="text-center" v-else>
            <!-- 메모리 차트 영역 -->
            <b-col class="animated fadeIn fadeOut" md="6">
              <b-row v-if="server.os_type != 'linux'">
                <b-col md="6">
                  <div v-if="info.chart.memory.series && info.chart.memory.series.length > 0">
                    <VueApexCharts type="area" height="150" ref="_chart_memory" :options="info.chart.memory" :series="info.chart.memory.series" />
                  </div>
                </b-col>
                <b-col md="6">
                  <div v-if="info.chart.memory.series && info.chart.memory.series.length > 0">
                    <VueApexCharts type="area" height="150" ref="_chart_cpu" :options="info.chart.cpu" :series="info.chart.cpu.series" />
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="server.os_type == 'linux'">
                <b-col>
                  <div v-if="info.chart.memory.series && info.chart.memory.series.length > 0">
                    <VueApexCharts type="area" height="150" ref="_chart_memory" :options="info.chart.memory" :series="info.chart.memory.series" />
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="server.os_type == 'linux'">
                <b-col>
                  <div v-if="info.chart.memory.series && info.chart.memory.series.length > 0">
                    <VueApexCharts type="area" height="150" ref="_chart_cpu" :options="info.chart.cpu" :series="info.chart.cpu.series" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div v-if="info.status.system_cpu_info && info.status.system_cpu_info.usages && info.status.system_cpu_info.usages.length > 0">
                    <VueApexCharts type="heatmap" height="140" ref="_chart_workload" :options="info.chart.workload" :series="info.chart.workload.series" />
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col v-if="info.is_online" class="rounded-lg pt-2 m-2 text-left animated fadeIn fadeOut">
              <folderSet :disk_list="disckStatus" />
            </b-col>
          </b-row>
        </b-collapse>
      </b-card-body>
      </b-card>
      <b-row v-if="!quick_setting_status" style="position:sticky; top:232px; z-index:15;">
        <b-col md="12">
          <b-input-group class="text-center">
            <span style="font-size:25px; position: absolute; top: 10px; margin-left: 15px; z-index: 20; color: #4f5b66;"><i class="fa fa-search"></i></span>
            <input style="box-shadow: 3px 3px 5px 1px gray; border-radius: 25px !important; font-weight:bold; font-size:26px !important;" class="form-control bg_gray" type="search" :value="search_key" @input="x => search_key = x.target.value" placeholder="정책 번호 또는 탐지 메세지를 입력해보세요">
          </b-input-group>
        </b-col>
      </b-row>

      <b-row class="text-center mt-4" v-if="server && !quick_setting_status && is_available_policy_request">
        <b-col class="text-left float-left">
          <p class="h4 font-weight-bold d-inline-block">요청(Request) 정책</p>
          <label class="d-inline-block float-right">
            <b-form-checkbox
            :checked="crs_count_preview"
            class="d-inline-block ml-4"
            name="check-button"
            switch
            @change="toggle_crs_count_preview"
          ></b-form-checkbox>
            요약 정보 표시
            <span class="text-info" v-b-tooltip.hover title="정책의 미사용, 탐지, 차단 정책의 수를 표시합니다">
              <i style="cursor:pointer" class="fas fa-question-circle"></i>
            </span>
          </label>
          <div style="width: 100%; height:40px;">
            <p class="h6 d-inline-block" style="padding-right:15px; position:relative; z-index:10; height: 20px; background-color:white">마우스를 올려 놓으면 공격 설명이 표시됩니다</p>
            <p class="d-inline-block mx-auto" style="height: 2px; background-color:gray; width:100%; position:relative; top:-22px;"></p>
            <!-- <div style="height: 2px; background-color:gray; width: 100%; position:absolute; top:42px;"></div> -->
          </div>
          <RuleCRS
              v-for="(item, index) in base_policy.request" v-bind:key="index + '_request'"
              v-if="item.i18n && item.is_available"
              :base_crs="item"
              :custom_crs="now_policy.custom_crs_dic[item.key]"
              :search="search_key"
              :summary="summary"
              :crs_count_preview="crs_count_preview"

              @save="save_policy_one"
            />
        </b-col>
      </b-row>

      <b-row class="text-center mt-4" v-if="server && !quick_setting_status && is_available_policy_process">
        <b-col class="text-left float-left">
          <p class="h4 font-weight-bold">처리(Processing) 정책</p>
          <div style="width: 100%; height:40px;">
            <p class="h6 d-inline-block" style="padding-right:15px; position:relative; z-index:10; height: 20px; background-color:white">마우스를 올려 놓으면 공격 설명이 표시됩니다</p>
            <p class="d-inline-block mx-auto" style="height: 2px; background-color:gray; width:100%; position:relative; top:-22px;"></p>
            <!-- <div style="height: 2px; background-color:gray; width: 100%; position:absolute; top:42px;"></div> -->
          </div>
          <RuleCRS
              v-for="(item, index) in base_policy.process" v-bind:key="index + '_request'"
              v-if="item.i18n && item.is_available"
              :base_crs="item"
              :custom_crs="now_policy.custom_crs_dic[item.key]"
              :search="search_key"
              :summary="summary"
              :crs_count_preview="crs_count_preview"

              @save="save_policy_one"
            />

        </b-col>
      </b-row>

      <b-row class="text-center mt-4" v-if="server && !quick_setting_status && is_available_policy_response">
        <b-col class="text-left float-left">
          <p class="h4 font-weight-bold">응답(Response) 정책</p>
          <div style="width: 100%; height:40px;">
            <p class="h6 d-inline-block" style="padding-right:15px; position:relative; z-index:10; height: 20px; background-color:white">마우스를 올려 놓으면 공격 설명이 표시됩니다</p>
            <p class="d-inline-block mx-auto" style="height: 2px; background-color:gray; width:100%; position:relative; top:-22px;"></p>
            <!-- <div style="height: 2px; background-color:gray; width: 100%; position:absolute; top:42px;"></div> -->
          </div>
          <RuleCRS
            v-for="(item, index) in base_policy.response" v-bind:key="index + '_request'"
            v-if="item.i18n && item.is_available"
            :base_crs="item"
            :custom_crs="now_policy.custom_crs_dic[item.key]"
            :search="search_key"
            :summary="summary"
            :crs_count_preview="crs_count_preview"

            @save="save_policy_one"
          />
        </b-col>
      </b-row>
      <b-row class="text-center mt-4" v-if="server && !quick_setting_status && is_available_policy_exclusion">
        <b-col class="text-left float-left">
          <p class="h4 font-weight-bold d-inline-block">제외(Exclusion) 정책</p>
          <span class="text-info" v-b-tooltip.hover title="서비스 가용성을 위해 사용하고 있는 서비스의 제외 정책을 제공합니다">
            <i style="cursor:pointer" class="fas fa-question-circle"></i>
          </span>
          <div style="width: 100%; height:40px;">
            <p class="h6 d-inline-block" style="padding-right:15px; position:relative; z-index:10; height: 20px; background-color:white">마우스를 올려 놓으면 공격 설명이 표시됩니다</p>
            <p class="d-inline-block mx-auto" style="height: 2px; background-color:gray; width:100%; position:relative; top:-22px;"></p>
          </div>
          <RuleCRS
              v-for="(item, index) in base_policy.exclusion" v-bind:key="index + '_request'"
              v-if="item.i18n && item.is_available"

              :base_crs="item"
              :custom_crs="now_policy.custom_crs_dic[item.key]"
              :search="search_key"
              :summary="summary"
              :crs_count_preview="crs_count_preview"

              @save="save_policy_one"
            />
        </b-col>
      </b-row>
    </b-card>

    <div class="d-flex flex-wrap align-items-center" v-if="server && !quick_setting_status && !loading">
      <div class="title mx-auto">
        추가 설정
        <button type="button" class="btn btn-sm btn-secondary ml-2" data-toggle="collapse" data-target="#more_option" id="Collapse-01">
          <span id="Collapse_text-01">SHOW</span>
          <span><i class="fas fa-plus-circle" id="Collapse_icon-01"></i></span>
        </button>
      </div>
      <span v-if="is_require_save" class="font-weight-bold text-danger" style="position:absolute;">
        * 정책 변경 사항이 있습니다 변경 사항을 확인하고 저장하세요
      </span>
    </div>

    <!-- 아래부터 옵션 설정 -->
    <hr v-if="!loading">

    <b-row id="more_option" class="collapse pb-5" style="margin-bottom: 4.0rem !important;">
      <b-col>
        <!-- 탭부분 시작 -->
        <b-tabs v-if="server && !quick_setting_status && !loading" class="animated fadeIn fadeOut" v-model="tab_index">
          <!-- ip 관련 접근 제어 -->
          <b-tab style="cursor: pointer;">
            <template #title>
              IP 설정
              및 도메인
              <div v-if="is_changed('ip_list') || is_changed('host_list')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <b-row>
              <b-col>
                <RuleCustom
                  valid="ip"
                  class="animated fadeIn fadeOut"
                  title="IP 주소 관리"
                  description="관리할 IP 주소(ex, '222.222.222.222')를 추가하세요"
                  tooltip="특정 아이피의 요청을 따로 설정합니다 ex) 1.1.1.1 일 경우 1.1.1.1 로 접근하는 아이피가 전부 차단됩니다"
                  :policy_list="now_policy.ip_list"

                  @update="(val) => { now_policy.ip_list = val; check_change(); }"
                />
              </b-col>
              <b-col>
                <RuleCustom
                  valid="domain"
                  :is_preview="now_policy.domain != 'default'"
                  class="animated fadeIn fadeOut"
                  title="도메인 관리"
                  description="관리할 도메인(ex, 'google.com')를 추가하세요"
                  tooltip="해당 정책은 default 정책에서만 설정 가능하며 정책에서 클라이언트의 요청에서 헤더의 host 필트를 기반으로 식별됩니다 특정 도메인을 탐지 혹은 차단하기 위해 설정합니다 ex) google.com 설정시 google.com 을 차단 혹은 탐지합니다"
                  :policy_list="now_policy.host_list"

                  @update="(val) => { now_policy.host_list = val; check_change(); }"
                />
              </b-col>
            </b-row>

          </b-tab>
          <!-- CUSTOM country code -->
          <b-tab style="cursor: pointer;">
            <template #title>
              국가
              <div v-if="is_changed('country_code') || is_changed('use_geoip')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <RuleCountry
              v-if="server.id"

              class="animated fadeIn fadeOut"
              tooltip="웹 요청 클라이언트의 공인 아이피를 국가 단위로 식별합니다 국가를 클릭하여 탐지 혹은 차단으로 설정할 수 있습니다 불필요 국가에서의 접근은 차단을 권장합니다"
              :agent_id="server.id"
              :use_geoip="now_policy.use_geoip"
              :policy_list="now_policy.country_code"
              gchart_id="_gchart_agent_ko"

              @update="(val) => { now_policy.country_code = val; check_change(); }"
              @update_toggle="(val) => { now_policy.use_geoip = val; check_change(); }"

            />
          </b-tab>
          <!-- 사용자 옵션 -->
          <b-tab style="cursor: pointer;">
            <template #title>
              경로 / 파라미터
              <div v-if="is_changed('path') || is_changed('parameter')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <b-row>
              <b-col>
                <!-- path 관련 사용자 정책 설정 -->
                <RuleCustom
                  class="animated fadeIn fadeOut"
                  title="경로 설정"
                  description="관리할 경로(ex, '/root')를 추가하세요"
                  tooltip="특정 경로가 포함된 요청을 따로 설정합니다 ex) http://f1security.co.kr/manager/index.html 일 경우 /manager 경로를 차단한다면 index.html 페이지도 설정에 따라 수행됩니다"
                  :policy_list="now_policy.path"

                  @update="(val) => { now_policy.path = val; check_change(); }"
                />
              </b-col>
              <b-col>
                <!-- parameter 관련 사용자 정책 설정 -->
                <RuleCustom
                  class="animated fadeIn fadeOut"
                  title="파라미터 설정"
                  description="관리할 파라미터(ex, 'id=password')를 추가하세요"
                  tooltip="특정 파라미터가 포함된 요청을 따로 설정합니다 ex) kyword=password 예시와 같이 암호 매개 변수를 차단하면 예시와 같은 암호의 매개 변수가 포함된 웹 요청이 설정에 따라 수행됩니다"
                  :policy_list="now_policy.parameter"

                  @update="(val) => { now_policy.parameter = val; check_change(); }"
                />
              </b-col>
            </b-row>
          </b-tab>
          <!-- custom 문법 체크가 필요함 -->
          <b-tab style="cursor: pointer;" title="사용자 정책(CRS) / 리다이렉션 설정">
            <template #title>
              사용자 정책(CRS) / 리다이렉션 설정
              <div v-if="is_changed('redirection') || is_changed('custom_policy')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <b-row>
              <b-col>
                <strong>
                  <b-badge variant="warning">공지</b-badge> : 전문가만 사용을 권장드립니다.
                  <span class="text-info" v-b-tooltip.hover title="사용자 지정 CRS 정책으로 CRS 문법에 맞게 작성되어야 합니다. 규칙 ID 6000000-+ ID를 지정하십시오">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
                <p class="mt-4">
                  예시 : "호스트 헤더가 IP 주소로 요청될 때" 탐지되는 규칙은 920350 입니다
                  <br>
                  Example : SecRuleUpdateActionById 920350 "t:none,msg:'Network Attack',allow"
                </p>

                <b-form-group>
                  <b-form-textarea @change="check_change" id="ph_content" v-model="custom_policy" :rows="crs_line_count()" :max-rows="80"></b-form-textarea>
                </b-form-group>
              </b-col>
              <b-col>
                <strong class="font-weight-bold">
                  <p>
                    리다이렉션 설정
                  </p>
                  탐지 공격시 리다이렉션을 설정합니다 해당 설정은 부가적인 기능입니다
                  <span class="text-info" v-b-tooltip.hover title="공격이 식별될 경우(정책에 의해 탐지될 경우) 지정한 URL 로 페이지를 리다이렉션합니다 미설정시 403 HTTP 권한 없음이 응답됩니다">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>

                <hr>
                <p>
                  <b-badge pill variant="primary">다음 버전에서 기능이 추가됩니다! </b-badge>
                  <!-- <b-button variant="link" @click="() => { now_policy.redirection = get_url(); check_change(); }">
                    Ex) {{ get_url() }}
                  </b-button> -->
                  <small v-if="is_changed('redirection')" class="float-right text-danger font-weight-bold">* 저장이 필요합니다</small>
                </p>

                <b-form-input :disabled="true" @change="check_change" :state="Boolean(now_policy.redirection)" placeholder="리다이렉션 URL 을 입력하세요" class="m-2" size="xl" v-model="now_policy.redirection"></b-form-input>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab style="cursor: pointer;">
            <template #title>
              자원 모니터링
              <div v-if="is_changed('agent.setting')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <b-row>
              <b-col class="text-center">
                <p style="display:inline-block; cursor: pointer;" @click="() => { agent_setting.limit_mode = !agent_setting.limit_mode; check_change(); }">
                  <span class="mr-3">자원 모니터링 알림 설정</span>
                  <i v-if="agent_setting.limit_mode" class="fa fa-refresh fa-spin"></i>
                </p>
                <c-switch @change="check_change" class="float-right" color="success" label variant="pill" v-model="agent_setting.limit_mode" />
                <br>
                <small class="text-danger">시스템 자원이 제한 이상일 경우 최초 1회 알림 발생 되며, 정상 기준이하시 재알림이 가능합니다. 제한는 90%, 정상 기준은 60% 를 권장합니다 </small>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col sm="2" class="mt-2">CPU 제한(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" placeholder="90" v-model="agent_setting.limit_cpu"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">RAM 제한(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" placeholder="90" v-model="agent_setting.limit_ram"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">Disk 제한(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" placeholder="90" v-model="agent_setting.limit_disk"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <!-- 여기서 라인 나눔 -->
              <b-col sm="2" class="mt-2">CPU 정상(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" v-model="agent_setting.resolve_cpu">
                  </b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">RAM 정상(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" v-model="agent_setting.resolve_ram">
                  </b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">Disk 정상(%)</b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input min="0" max="100" v-on:input="check_change()" :disabled="!agent_setting.limit_mode" :number="true" type="number" v-model="agent_setting.resolve_disk">
                  </b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-tab>
          <!-- 기본 제한 값 변경 -->
          <b-tab style="cursor: pointer;" v-if="false">
            <template #title>
              제한 설정
              <div v-if="is_changed('limit')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
            <!-- 요청 -->
            <b-row class="text-center">
              <b-col sm="4" class="mt-2">
                <strong class="font-weight-bold">
                  요청
                </strong>
              </b-col>
              <b-col sm="2" class="mt-2">
                <strong class="font-weight-bold">
                  요청 데이터 제한(Byte) - 파일 전송
                  <span class="text-info" v-b-tooltip.hover title="클라이언트가 요청하는 body 데이터의 제한을 설정합니다, 업로드가 다양하게 활용되는 사이트일 경우 값 변경을 권장합니다">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
              </b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input @change="check_change" :number="true" type="number" v-model="now_policy.limit.request_body_limit"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">
                <strong class="font-weight-bold">
                  요청 데이터 제한(Byte) - 파일 미전송
                  <span class="text-info" v-b-tooltip.hover title="클라이언트가 요청하는 body 데이터의 제한을 설정합니다, 파일 전송 없이 application/x-www-form-urlencoded 로 전송될 경우에 해당됩니다">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
              </b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input @change="check_change" :number="true" type="number" v-model="now_policy.limit.request_body_limit_no_file"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>

            <!-- 응답 -->
            <b-row class="text-center">
              <b-col sm="4" class="mt-2">
                <strong class="font-weight-bold">
                  응답
                </strong>
              </b-col>

              <b-col sm="2" class="mt-2">
                <strong class="font-weight-bold">
                  응답 데이터 제한(Byte)
                  <span class="text-info" v-b-tooltip.hover title="클라이언트의 요청에 대한 웹서버의 응답 최대 데이터 크기를 설정합니다 이 이상일 경우 응답하지 않습니다">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
              </b-col>
              <b-col sm="2">
                <b-input-group class="mt-1 mb-1">
                  <b-form-input @change="check_change" :number="true" type="number" v-model="now_policy.limit.response_body_limit"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="2" class="mt-2">
                <!-- <strong class="font-weight-bold">
                  요청 데이터 제한(Byte) - 파일 미전송
                  <span class="text-info" v-b-tooltip.hover title="클라이언트가 요청하는 body 데이터의 제한을 설정합니다, 파일 전송 없이 application/x-www-form-urlencoded 로 전송될 경우에 해당됩니다">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong> -->
              </b-col>
              <b-col sm="2">
                <!-- <b-input-group class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="now_policy.limit.request_body_limit"></b-form-input>
                </b-input-group> -->
              </b-col>
            </b-row>

            <!-- 공용 -->
            <b-row class="text-center">
              <b-col sm="4" class="mt-2">
                <strong class="font-weight-bold">
                  공통 (요청 + 응답)
                  <span class="text-info" v-b-tooltip.hover title="웹서버에서 지원하는 MIME 타입을 설정할 수 있습니다 기본값으로 text/plain, text/html, text/xml 3가지만 활성화 됩니다">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </strong>
              </b-col>
              <b-col class="text-center">
                <multiselect
                  v-model="now_policy.limit.mime_type"
                  tag-placeholder="선택해주세요"
                  placeholder="선택해주세요"
                  :options="codes.WAF_MIME_TYPE"
                  :multiple="true"
                  :taggable="false"
                  @input="check_change"
                >
                </multiselect>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab style="cursor: pointer;" :disabled="true">
            <template #title>
              API 보안 (준비중)
              <div v-if="is_changed('agent_setting')" style="width: 10px; height:10px; background-color:red; border-radius:10px; float:right; margin-left:5px;"></div>
            </template>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>

    <!-- 정책 저장 전 변경 확인 모달 -->
    <b-modal size="xl" title="정책을 적용할까요 ?" class="modal-warning" v-model="rule_confirm" @ok="save_policy_option" ok-variant="danger"
      header-bg-variant="danger">
      <b-row>
        <b-col>
          <p>
            변경 사항이 있는 정책을 표시합니다
            <strong class="text-danger">
              잘못된 규칙 설정이 서비스에 영향을 줄 수 있습니다. 아래의 변경 사항 표시는 사용자 정책만 표시됩니다
            </strong>
          </p>
        </b-col>
      </b-row>

      <!-- 서버의 도메인 설정(전체적 설정) -->
      <!-- 도메인 관리 -->
      <b-row v-if="is_changed('domain')" class="mt-4 text-center">
        <b-col>
          <b-table v-if="get_unsaved_preview_domain()" striped hover small fixed class="table_add" :items="get_unsaved_preview_domain()" empty-text="not found">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template slot="domain" slot-scope="row">
              {{row.item.domain}}
            </template>
            <template slot="type" slot-scope="row">
              {{row.item.type}}
            </template>
          </b-table>
        </b-col>
      </b-row>

      <!-- IP 주소, 도메인 예외 -->

      <!-- ip 관리 -->
      <b-row v-if="is_changed('ip_list')" class="mt-4 text-center">
        <b-col>
          <strong class="text-danger">변경 전</strong>
          <RuleCustom
            :is_preview="true"
            class="animated fadeIn fadeOut"
            title="IP 주소 관리"
            description="관리할 IP 주소(ex, '222.222.222.222')를 추가하세요"
            tooltip="특정 아이피의 요청을 따로 설정합니다 ex) 1.1.1.1 일 경우 1.1.1.1 로 접근하는 아이피가 전부 차단됩니다"
            :policy_list="get_origin_policy('ip_list')"
          />
        </b-col>
        <b-col>
          <strong class="text-danger">변경 후</strong>
          <RuleCustom
            :is_preview="true"
            class="animated fadeIn fadeOut"
            title="IP 주소 관리"
            description="관리할 IP 주소(ex, '222.222.222.222')를 추가하세요"
            tooltip="특정 아이피의 요청을 따로 설정합니다 ex) 1.1.1.1 일 경우 1.1.1.1 로 접근하는 아이피가 전부 차단됩니다"
            :policy_list="now_policy.ip_list"
          />
        </b-col>
      </b-row>

      <!-- 도메인 관리 -->
      <b-row v-if="is_changed('host_list')" class="mt-4 text-center">
        <b-col>
          <strong class="text-danger">변경 전</strong>
          <RuleCustom
            :is_preview="true"
            class="animated fadeIn fadeOut"
            title="도메인 관리"
            description="관리할 도메인(ex, 'google.com')를 추가하세요"
            tooltip="해당 정책은 default 정책에서만 설정 가능하며 정책에서 클라이언트의 요청에서 헤더의 host 필트를 기반으로 식별됩니다 특정 도메인을 탐지 혹은 차단하기 위해 설정합니다 ex) google.com 설정시 google.com 을 차단 혹은 탐지합니다"
            :policy_list="get_origin_policy('host_list')"
          />
        </b-col>
        <b-col>
          <strong class="text-danger">변경 후</strong>
          <RuleCustom
            :is_preview="true"
            class="animated fadeIn fadeOut"
            title="도메인 관리"
            description="관리할 도메인(ex, 'google.com')를 추가하세요"
            tooltip="해당 정책은 default 정책에서만 설정 가능하며 정책에서 클라이언트의 요청에서 헤더의 host 필트를 기반으로 식별됩니다 특정 도메인을 탐지 혹은 차단하기 위해 설정합니다 ex) google.com 설정시 google.com 을 차단 혹은 탐지합니다"
            :policy_list="now_policy.host_list"
          />
        </b-col>
      </b-row>

      <!-- 국가 -->
      <b-row v-if="is_changed('country_code') || is_changed('use_geoip')" class="text-center mt-4">
        <b-col>
          <strong class="text-danger">변경 전</strong>
          <b-form-checkbox
            :checked="now_policy.use_geoip_origin"
            class="d-inline-block ml-4"
            :disabled="true"
            name="check-button"
            switch
          ></b-form-checkbox>
          <RuleCountry
            title="GEO 정책"
            class="animated fadeIn fadeOut"
            :is_preview="true"
            tooltip="웹 요청 클라이언트의 공인 아이피를 국가 단위로 식별합니다 국가를 클릭하여 탐지 혹은 차단으로 설정할 수 있습니다 불필요 국가에서의 접근은 차단을 권장합니다"
            :agent_id="server.id"
            :use_geoip="now_policy.use_geoip_origin"
            :policy_list="get_origin_policy('country_code')"

          />
        </b-col>
        <b-col>
          <strong class="text-danger">변경 후</strong>
          <b-form-checkbox
            class="d-inline-block ml-4"
            :checked="now_policy.use_geoip"
            :disabled="true"
            name="check-button"
            switch
          ></b-form-checkbox>

          <RuleCountry
            title="GEO 정책"
            class="animated fadeIn fadeOut"
            :is_preview="true"
            tooltip="웹 요청 클라이언트의 공인 아이피를 국가 단위로 식별합니다 국가를 클릭하여 탐지 혹은 차단으로 설정할 수 있습니다 불필요 국가에서의 접근은 차단을 권장합니다"
            :agent_id="server.id"
            :use_geoip="now_policy.use_geoip"
            :policy_list="now_policy.country_code"

          />
        </b-col>
      </b-row>

      <!-- 경로 / 파라미터  -->
      <b-row v-if="is_changed('path')" class="mt-4 text-center">
        <!-- 경로 설정 -->
        <b-col>
          <strong class="text-danger">변경 전</strong>
          <RuleCustom
            :policy_list="get_origin_policy('path')"
            is_preview="true"
            class="animated fadeIn fadeOut"
            title="경로 설정"
            tooltip="특정 경로가 포함된 요청을 따로 설정합니다 ex) http://f1security.co.kr/manager/index.html 일 경우 /manager 경로를 차단한다면 index.html 페이지도 설정에 따라 수행됩니다"
          />
        </b-col>
        <b-col>
          <strong class="text-danger">변경 후</strong>
          <RuleCustom
            :policy_list="now_policy.path"
            is_preview="true"
            class="animated fadeIn fadeOut"
            title="경로 설정"
            tooltip="특정 경로가 포함된 요청을 따로 설정합니다 ex) http://f1security.co.kr/manager/index.html 일 경우 /manager 경로를 차단한다면 index.html 페이지도 설정에 따라 수행됩니다"
          />
        </b-col>
      </b-row>

      <!-- 파라미터 설정 -->
      <b-row v-if="is_changed('parameter')" class="mt-4 text-center">
        <b-col>
          <strong class="text-danger">변경 전</strong>
          <RuleCustom
            :policy_list="get_origin_policy('parameter')"
            is_preview="true"
            class="animated fadeIn fadeOut mt-4"
            title="파라미터 설정"
            tooltip="특정 파라미터가 포함된 요청을 따로 설정합니다 ex) kyword=password 예시와 같이 암호 매개 변수를 차단하면 예시와 같은 암호의 매개 변수가 포함된 웹 요청이 설정에 따라 수행됩니다"
          />
        </b-col>
        <b-col>
          <strong class="text-danger">변경 후</strong>
          <RuleCustom
            :policy_list="now_policy.parameter"
            is_preview="true"
            class="animated fadeIn fadeOut mt-4"
            title="파라미터 설정"
            tooltip="특정 파라미터가 포함된 요청을 따로 설정합니다 ex) kyword=password 예시와 같이 암호 매개 변수를 차단하면 예시와 같은 암호의 매개 변수가 포함된 웹 요청이 설정에 따라 수행됩니다"
          />
        </b-col>
      </b-row>

      <!-- 사용자 정책 -->
      <b-row v-if="is_changed('custom_policy')" class="mt-4">
        <b-col>
          <p class="text-center">
            <strong class="text-danger">변경 전</strong> 사용자 정책(CRS)
          </p>
          <textarea style="width: 100%; height: auto; max-height: 80px;" :value="base64decode(now_policy.custom_policy.trim())" :rows="crs_line_count('custom_rule')" :disabled="true"></textarea>
        </b-col>
        <b-col v-if="is_changed('custom_policy')">
          <p class="text-center">
            <strong class="text-danger">변경 후</strong> 사용자 정책(CRS)
          </p>
          <textarea style="width: 100%; height: auto; max-height: 80px;" v-model="custom_policy" :rows="crs_line_count('origin_custom_rule')" :disabled="true"></textarea>
        </b-col>
      </b-row>

      <!-- 리다이렉션 설정 -->
      <b-row v-if="is_changed('redirection')" class="mt-4">
        <b-col>
          <strong class="font-weight-bold">
            <p>
              <strong class="text-danger">변경 전</strong> 리다이렉션 설정
            </p>
          </strong>
          <hr>
          <b-form-input :disabled="true" :state="Boolean(now_policy.redirection_origin)" placeholder="리다이렉션 URL 을 입력하세요" class="m-2" size="xl" :value="now_policy.redirection_origin"></b-form-input>
        </b-col>
        <b-col>
          <strong class="font-weight-bold">
            <p>
              <strong class="text-danger">변경 후</strong> 리다이렉션 설정
            </p>
          </strong>
          <hr>
          <b-form-input :disabled="true" :state="Boolean(now_policy.redirection)" placeholder="리다이렉션 URL 을 입력하세요" class="m-2" size="xl" :value="now_policy.redirection"></b-form-input>
        </b-col>
      </b-row>

      <!-- 에이전트 설정 변경 사항 -->
      <b-row v-if="is_changed('agent.setting')" class="mt-4">
        <!-- 자원 모니터링 -->
        <b-col class="text-center">
          <p style="display:inline-block; cursor: pointer;">
            <span class="mr-3">
              <strong class="text-danger">변경 전</strong>
              자원 모니터링 알림 설정
            </span>
            <i v-if="agent_setting && agent_setting.limit_mode != JSON.parse(server.setting).limit_mode && JSON.parse(server.setting).limit_mode" class="fa fa-refresh fa-spin"></i>
          </p>
          <b-form-checkbox
            class="d-inline-block ml-4"
            :disabled="true"
            :checked="JSON.parse(server.setting).limit_mode"
            name="check-button"
            switch
            v-if="agent_setting && agent_setting.limit_mode != JSON.parse(server.setting).limit_mode"
          >
          </b-form-checkbox>
        </b-col>

        <b-col class="text-center text-weight-bold">
          <p style="display:inline-block; cursor: pointer;">
            <span class="mr-3">
              <strong class="text-danger">변경 후</strong>
              자원 모니터링 알림 설정
            </span>
            <i v-if="agent_setting && agent_setting.limit_mode != JSON.parse(server.setting).limit_mode && agent_setting.limit_mode" class="fa fa-refresh fa-spin"></i>
          </p>
          <b-form-checkbox
              class="d-inline-block ml-4"
              :disabled="true"
              :checked="agent_setting.limit_mode"
              name="check-button"
              switch
              v-if="agent_setting && agent_setting.limit_mode != JSON.parse(server.setting).limit_mode"
            >
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row v-if="is_changed('agent.setting')">
        <b-col>
          <!-- 설정 데이터 -->
          <b-row>
            <b-col sm="2" class="mt-2">CPU 제한</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" placeholder="90" v-model="JSON.parse(server.setting).limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 제한</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" placeholder="90" v-model="JSON.parse(server.setting).limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 제한</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" placeholder="90" v-model="JSON.parse(server.setting).limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- 여기서 라인 나눔 -->
            <b-col sm="2" class="mt-2">CPU 정상</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" v-model="JSON.parse(server.setting).resolve_cpu">
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 정상</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" v-model="JSON.parse(server.setting).resolve_ram">
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 정상</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" v-model="JSON.parse(server.setting).resolve_disk">
                </b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <!-- 설정 데이터 -->
          <b-row v-if="is_changed('agent.setting')">
            <b-col sm="2" class="mt-2">CPU 제한</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" placeholder="90"
                  v-model="agent_setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 제한</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" placeholder="90"
                  v-model="agent_setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 제한</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number" placeholder="90"
                  v-model="agent_setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- 여기서 라인 나눔 -->
            <b-col sm="2" class="mt-2">CPU 정상</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number"
                  v-model="agent_setting.resolve_cpu">
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 정상</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number"
                  v-model="agent_setting.resolve_ram">
                </b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 정상</b-col>
            <b-col sm="2">
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" :number="true" type="number"
                  v-model="agent_setting.resolve_disk">
                </b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- 제한 설정 -->
      <b-row v-if="is_changed('limit')" class="mt-4 text-center">
        <b-col>
          <strong class="text-danger">변경 전</strong>
          <!-- 요청 -->
          <b-row class="mt-2">
            <b-col>
              <strong class="font-weight-bold">
                요청 데이터 제한(Byte) - 파일 전송
                <span class="text-info" v-b-tooltip.hover title="클라이언트가 요청하는 body 데이터의 제한을 설정합니다, 업로드가 다양하게 활용되는 사이트일 경우 값 변경을 권장합니다">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-if="now_policy.limit_origin" :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit_origin.request_body_limit"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <strong class="font-weight-bold">
                요청 데이터 제한(Byte) - 파일 미전송
                <span class="text-info" v-b-tooltip.hover title="클라이언트가 요청하는 body 데이터의 제한을 설정합니다, 파일 전송 없이 application/x-www-form-urlencoded 로 전송될 경우에 해당됩니다">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-if="now_policy.limit_origin" :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit_origin.request_body_limit_no_file"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <!-- 응답 -->
          <b-row class="text-center mt-2">
            <b-col>
              <strong class="font-weight-bold">
                응답 데이터 제한(Byte)
                <span class="text-info" v-b-tooltip.hover title="클라이언트의 요청에 대한 웹서버의 응답 최대 데이터 크기를 설정합니다 이 이상일 경우 응답하지 않습니다">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input v-if="now_policy.limit_origin" :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit_origin.response_body_limit"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <!-- 공용 -->
          <b-row>
            <b-col class="mt-2">
              <strong class="font-weight-bold">
                공통 (요청 + 응답)
                <span class="text-info" v-b-tooltip.hover title="웹서버에서 지원하는 MIME 타입을 설정할 수 있습니다 기본값으로 text/plain, text/html, text/xml 3가지만 활성화 됩니다">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col class="text-center" v-if="now_policy.limit_origin && now_policy.limit_origin.mime_type">
              <multiselect
                :disabled="true"
                v-model="now_policy.limit_origin.mime_type"
                tag-placeholder="선택해주세요"
                placeholder="선택해주세요"
                :options="codes.WAF_MIME_TYPE"
                :multiple="true"
                :taggable="false"
                @input="check_change"
              >
              </multiselect>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <strong class="text-danger mt-2">변경 후</strong>
          <!-- 요청 -->
          <b-row class="mt-2">
            <b-col>
              <strong class="font-weight-bold">
                요청 데이터 제한(Byte) - 파일 전송
                <span class="text-info" v-b-tooltip.hover title="클라이언트가 요청하는 body 데이터의 제한을 설정합니다, 업로드가 다양하게 활용되는 사이트일 경우 값 변경을 권장합니다">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit.request_body_limit"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <strong class="font-weight-bold">
                요청 데이터 제한(Byte) - 파일 미전송
                <span class="text-info" v-b-tooltip.hover title="클라이언트가 요청하는 body 데이터의 제한을 설정합니다, 파일 전송 없이 application/x-www-form-urlencoded 로 전송될 경우에 해당됩니다">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit.request_body_limit_no_file"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <!-- 응답 -->
          <b-row class="text-center mt-2">
            <b-col>
              <strong class="font-weight-bold">
                응답 데이터 제한(Byte)
                <span class="text-info" v-b-tooltip.hover title="클라이언트의 요청에 대한 웹서버의 응답 최대 데이터 크기를 설정합니다 이 이상일 경우 응답하지 않습니다">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
            <b-col>
              <b-input-group class="mt-1 mb-1">
                <b-form-input :disabled="true" @change="check_change" :number="true" type="number" v-model="now_policy.limit.response_body_limit"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <!-- 공용 -->
          <b-row class="mt-2">
            <b-col>
              <strong class="font-weight-bold">
                공통 (요청 + 응답)
                <span class="text-info" v-b-tooltip.hover title="웹서버에서 지원하는 MIME 타입을 설정할 수 있습니다 기본값으로 text/plain, text/html, text/xml 3가지만 활성화 됩니다">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col class="text-center">
              <multiselect
                :disabled="true"
                v-model="now_policy.limit.mime_type"
                tag-placeholder="선택해주세요"
                placeholder="선택해주세요"
                :options="codes.WAF_MIME_TYPE"
                :multiple="true"
                :taggable="false"
                @input="check_change"
              >
              </multiselect>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </b-modal>

    <!-- TODO : 레벨 개념 활용시 추가 예정 -->
    <!-- <b-modal title="Explain Level Coverage" class="modal-info text-center" v-model="explain_level" ok-only
      no-close-on-backdrop ok-variant="success">
      <div class="text-center">
        <img src="img/waf_level.png" class="text-center" style="margin-left: auto; margin-right: auto;width: 90%;">
      </div>
      <hr>
      레벨4는 정책레벨 1 ~ 4 로 탐지합니다.<br>
      레벨3는 정책레벨 1 ~ 3 로 탐지합니다.<br>
      레벨2는 정책레벨 1 ~ 2 로 탐지합니다.<br>
      레벨1은 정책레벤 1로 탐지합니다.<br>
      <hr>
      <p>
        레벨이 높을수록 보다 많은 범위의 공격이 탐지됩니다.
        <br>
        레벨 설정 후, 상세 정책 설정을 권장합니다
        <br>
        레벨이 높을수록 오탐이 발생할 수 있습니다 예외 처리 및 관리가 필요합니다
      </p>
    </b-modal> -->

    <!-- TODO : 다른 서버로 정책 복사 기능은 2022.08 에서 지원 예정 -->
    <!-- 다른 서버에 정책 적용 모달 -->
    <!-- <b-modal hide-footer title="해당 정책을 다른 에이전트에 적용" size="xl" v-model="apply_modal" header-bg-variant='warning'>
      <b-button size="sm" variant="warning" @click="policy_list = []"> 지우기 </b-button>
      <hr>
      <p class="m-2">
        <b-form-checkbox-group class="m-2" v-model="policy_list">
          <b-form-checkbox v-for="policy in server.policy_json.domains" :key="policy.id" :value="policy.domain">
            {{policy.domain}}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </p>
      <hr v-if="apply_all_server && apply_all_server.length > 0">
      <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index" class="m-1">
        <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.nickname}} <span class="m-1"
            style="cursor:pointer;">X</span></h6>
      </b-badge>
      <hr>
      <agent-List :agent_id="server.id" :list_selected="apply_all_server" :only_select="true" @multi_clear="multi_clear"
        @multi_all="multi_all" @multi_one="multi_one"></agent-List>
      <hr>
      <b-button block variant="warning" @click="apply_confirm_modal = true" class="m-1 btn-addition">정책 저장하기</b-button>
      <b-button block variant="info" @click="apply_modal = false" class="m-1">닫기</b-button>
    </b-modal> -->

    <!-- 다른 서버 적용 모달 다시 확인 -->
    <!-- <b-modal hide-footer title="Confirm for apply to policy" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
      선택한 에이전트에 설정을 적용하시겠습니까?
      <hr>
      <b-button block variant="danger" @click="multi_save" class="m-1 btn-addition">적용</b-button>
      <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">닫기</b-button>
    </b-modal> -->

    <!-- 모드 설명 모달 -->
    <b-modal title="이중화 지원 범위"  class="modal-info text-center" v-model="modal_duplex" ok-only no-close-on-backdrop ok-variant="success">
      <b-badge variant="info">안내</b-badge> :
      <strong> 웹방화벽은 아래의 웹서버 이중화를 지원합니다 </strong><br>
      <hr>
      <p>
        <strong> * Active-Active : 2개의 이상의 상시 서버 운영 환경 </strong>
      </p>
      <p>
        <strong> * Active-Stanby : 1개의 상시 서버, 그 외 장애 대응 서버 운영 환경 </strong>
      </p>
      <p>
        <strong> * Auto Scale Out/In : 오토스케일링(아웃/인)으로 인한 유동적 환경</strong>
      </p>
      <hr>
      <p class="text-center">
        <b-img v-bind="{ width: 300, height: 300, class: 'm1' }" src="img/multi.png" alt="Multiplexing"></b-img>
      </p>
    </b-modal>

    <!-- 방화벽 도메인 안내 모달 -->
    <b-modal hide-footer title="" class="modal-info" size="xl" v-model="toggle.modal_domain_manage" no-close-on-backdrop ok-only>
      <div class="w-100 m-4 float-left">
        <img src="img/icons/conf_logo.png" width="100" alt="" style="vertical-align: top;">
        <div class="d-inline-block ml-5" style="width: 80%;">
          <span class="h4 font-weight-bold">도메인 관리</span>
          <p class="m-2">default 정책이란 ? 웹방화벽에서 사용하는 기본 정책입니다 도메인별로 정책 설정이 가능합니다 특정 도메인만 정책 설정이 필요한 경우 도메인을 추가해주세요</p>
          <p class="m-2">
            기본 정책(default) 비활성화를 원하실 경우 사용할 도메인을 등록해주세요 기본 정책(default)외의 도메인이 존재해야 기본 정책(default) 비활성화가 가능합니다
          </p>
        </div>
      </div>
      <hr>
      <b-table v-if="server && server.policy_json && server.policy_json.domains" ref="_list" striped hover small fixed class="table_add" :items="server.policy_json.domains" :fields="domain_manage_fields" empty-text="not found">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template slot="domain" slot-scope="row">
          <span v-if="now_policy.domain == row.item.domain" class="d-inline-block font-weight-bold font_15">
            *
          </span>
          <b-form-input style="text-align: left;" :disabled="('default' == row.item.domain && row.index == 0) || row.item.is_save != false" class="d-inline-block m-1" size="sm" v-model="row.item.domain"></b-form-input>
          <b-badge v-if="row.item.is_save === false" class="d-inline-block" variant="danger">미저장</b-badge>
        </template>
        <template slot="button" slot-scope="row">
          <b-button size="sm" :disabled="is_add_domain_lock || row.item.temp" variant="dark" @click="domain_manage_regist('', row.item.domain)">복사하기</b-button>
          <!-- <b-button size="sm" :disabled="is_add_domain_lock || row.item.temp" variant="info" @click="domain_manage_regist('', row.item.domain)">수정하기</b-button> -->
          <!-- TODO : 운영 모드별 설정 -->
          <!-- <b-button v-b-tooltip.hover title="준비중인 기능입니다" :disabled="true" size="sm" variant="warning" @click="domain_direct_remove(row.item)">테스트모드</b-button>
          <b-button v-b-tooltip.hover title="준비중인 기능입니다" :disabled="true" size="sm" variant="info" @click="domain_direct_remove(row.item)">운영모드</b-button>
          <b-button v-b-tooltip.hover title="준비중인 기능입니다" :disabled="true" size="sm" variant="primary" @click="domain_direct_remove(row.item)">호스팅사모드</b-button> -->

          <b-button :disabled="is_add_domain_lock" v-if="row.item.domain != 'default'" size="sm" variant="outline-danger" @click="domain_manage_remove(row.item.domain)">삭제</b-button>

          <!-- 다른 도메인이 있을 경우 비활성화 가능 -->
          <!-- defalut -->
          <div class="checkbox-switch mr-1 ml-1" v-b-tooltip.hover title="기본 정책입니다 추가 도메인이 있을 경우 비활성화가 가능합니다" style="vertical-align: middle;">
            <input type="checkbox" class="input-checkbox" name="default" v-model="row.item.is_alive" :disabled="row.item.domain == 'default' && server.policy_json.domains.length < 2">
            <div class="checkbox-animate" :class="{ disabled : row.item.domain == 'default' && server.policy_json.domains.length < 2 }">
                <span class="checkbox-off">미사용</span>
                <span class="checkbox-on">사용</span>
            </div>
          </div>
        </template>
      </b-table>
      <hr>
      <b-row class="text-center">
        <b-col>
          <span v-if="!auth.license.onPremise" class="float-left font-weight-bold text-danger">과금시, 서브 도메인은 하나의 도메인으로 구분합니다.</span>
          <b-form-input :disabled="is_add_domain_lock" class="d-inline-block m-1" size="sm" v-model="new_domain" @keyup.native.enter="domain_manage_regist(new_domain)" placeholder="Domain Add Enter" style="width: 70%;"></b-form-input>
          <b-button :disabled="is_add_domain_lock" class="btn-addition d-inline-block m-1" size="sm" variant="success" @click="domain_manage_regist(new_domain)">추가</b-button>
          <b-button class="d-inline-block m-1" size="sm" @click="toggle.modal_domain_manage = false">닫기</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- 도메인 삭제 모달 -->
    <b-modal title="Domain Remove" class="modal-danger" v-model="modal_domain_remove" no-close-on-backdrop @ok="domain_manage_remove()" header-bg-variant="danger">
      기존 존재한 도메인 삭제시 작업 사항이 같이 저장됩니다
      기존 도메인 설정은 삭제됩니다
      삭제하시겠습니까?
    </b-modal>

    <!-- 정책 버전 업데이트 모달 -->
    <b-modal title="정책 기본 버전 변경" class="modal-warning text-center" v-model="change_main_policy" no-close-on-backdrop ok-variant="success" hide-footer>
      <b-badge variant="warning">안내</b-badge>
      <strong> 방화벽 정책 변경 </strong>
      <hr>
      <p>정책 버전 [ {{crs_rule.version}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.version}}
          ]</span> </p>
      <hr>
      <p>필요한 최소 에이전트 버전 [ {{crs_rule.agent_version ? crs_rule.agent_version : '-'}} ] => <span
          class="font-weight-bold text-danger">[ {{target_crs_rule.agent_version ? target_crs_rule.agent_version : '-'}}
          ]</span> </p>
      <hr>
      <p class="text-danger">* 기본 정책을 변경하여 페이지가 새로 고쳐집니다</p>
      <hr>
      <small class="font-weight-bold">* 정책을 변경한 후 문제가 발생하면 정책을 다시 복원할 수 있습니다</small>
      <hr>
      <div class="modal-footer">
        <!-- <b-button block class="btn btn-success" @click="change_crs">업데이트</b-button> -->
        <b-button block class="btn btn-light" @click="change_main_policy = false; target_crs_rule = crs_rule;">취소</b-button>
      </div>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="서버 이름 수정" class="modal-warning text-center" v-model="name_modify_modal" no-close-on-backdrop
      ok-variant="success" hide-footer header-bg-variant="info">
      <p> 서버의 이름을 수정할 수 있습니다. </p>
      <p> 변경할 이름을 기입하세요. 초기 서버 이름은 서버의 호스트명입니다 </p>
      <p> <b> * 서버 이름 확인 </b> </p>
      <p> 변경 전 서버 이름 : {{server.nickname}} </p>
      <b-form-input v-model="modify_name" placeholder="변경할 이름을 입력하세요"></b-form-input>

      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="name_modify()">적용</b-button>
        <b-button block class="btn btn-light" @click="name_modify_modal = false">취소</b-button>
      </div>
    </b-modal>

    <!-- 로그 상세 모달 -->
    <b-modal size="xl" class="modal-warning text-center" v-model="toggle.modal_log" no-close-on-backdrop ok-variant="success"
      hide-footer header-bg-variant="info">
      <LogDetail :id="modal_log_id" @reload="get()" @policy_id="(value) => { toggle.modal_log = false; search_key = value; }" :only_view="false" />
    </b-modal>

    <!-- 적용 실패 안내 -->
    <b-modal :title="webcastle_alert_is_error ? '장애 알림' : '저장 성공'" size="ml"
      :class="`modal-${webcastle_alert_is_error ? 'danger' : 'success'} text-center`" v-model="webcastle_alert"
      no-close-on-backdrop :ok-variant="webcastle_alert_is_error ? 'danger' : 'success'" ok-only
      :header-bg-variant="webcastle_alert_is_error ? 'danger' : 'success'">
      <h4 v-if="webcastle_alert_is_error" class="text-danger font-weight-bold">변경된 정책을 적용 중 문제가 발생하였습니다</h4>
      <h4 v-if="webcastle_alert_is_error" class="text-danger font-weight-bold">웹 방화벽 장애 상태로 이전 설정으로 저장이 필요합니다</h4>
      <h4 v-else class="font-weight-bold"></h4>
      <hr>
      <p>
        msg : {{ webcastle_alert_msg || '-' }}
      </p>
      <br>
    </b-modal>

    <!-- 설정 업로드 모달 -->
    <b-modal title="정책 업로드" size="ml" class="modal-info" v-model="modal_upload_policy" no-close-on-backdrop ok-variant="success" ok-only header-bg-variant="success" @ok="upload_policy_save">
      <b-form-file
        :state="Boolean(upload_policy_file)"
        placeholder="정책 JSON 파일을 업로드 해주세요"
        drop-placeholder="정책 JSON 파일을 업로드 해주세요"
        @change="upload_policy_change"
      ></b-form-file>
      <hr v-if="upload_policy_data">
      <b-form-checkbox class="d-block m-2" v-for="(item, index) in upload_policy_data.domains" v-model="upload_policy_selected" :key="item.domain" :value="item.domain">
        {{item.domain}}
      </b-form-checkbox>
      <hr>
      <span class="text-danger">* 매칭되는 도메인 설정은 덮어쓰기, 없는 정책은 생성됩니다</span>
      <br>
      <span class="text-danger">* 정책 파일이 정확하지 않을 경우 업로드 실패할 수 있습니다</span>
      <br>
      <span class="text-danger">* 업로드 된 정책은 꼭 확인 후 저장하세요</span>
    </b-modal>

    <!-- 서버 삭제 안내 모달 -->
    <b-modal title="서버 삭제" class="modal-danger" v-model="toggle.modal_del" @ok="remove" @cancel="del_nickname = '';"
      header-bg-variant="danger" ok-variant="danger">
      <p> 이곳에서 에이전트를 삭제해도 서버에서는 자동삭제되지 않습니다. 먼저 서버에서 삭제할 것을 권장드립니다. </p>
      <p> 삭제된 경우 방화벽 역활을 수행하지 않습니다. </p>
      <p> <b> * 서버 이름 확인 </b> </p>
      <p> 삭제할 서버이름 확인 : {{server.nickname}} </p>
      <b-form-input v-model="del_nickname" placeholder="삭제할 서버의 이름을 입력해주세요."></b-form-input>
    </b-modal>


    <!-- 정책 업그레이드 모달 -->
    <b-modal title="정책 업그레이드" class="modal-danger text-center" v-model="upgrade_policy_modal" no-close-on-backdrop
      ok-variant="success" hide-footer header-bg-variant="info">
      <p> 준비중인 기능입니다 </p>
      <!-- <p> 변경할 이름을 기입하세요. 초기 서버 이름은 서버의 호스트명입니다 </p>
      <p> <b> * 서버 이름 확인 </b> </p>
      <p> 변경 전 서버 이름 : {{server.nickname}} </p>
      <b-form-input v-model="modify_name" placeholder="변경할 이름을 입력하세요"></b-form-input> -->

      <div class="modal-footer">
        <!-- <b-button block class="btn btn-success" @click="name_modify()">적용</b-button> -->
        <b-button block class="btn btn-light" @click="upgrade_policy_modal = false">취소</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
